import cookie from 'cookie'
import { debounce } from 'lodash'
import getLastSearchResponseId from 'shared/util/get-last-search-id'
import Logger from 'shared/util/log'
import { pingbackDebounceTime, pingbackUrl } from './pingback-networking'
import { PingbackRequestAction, Session, SessionEvent } from './pingback-types'

// add new types here
export type WebAppPingbackEventType = 'DROPDOWN_AUTOCOMPLETE' | 'DROPDOWN_CHANNEL_SUGGEST' | 'DROPDOWN_TRENDING_SUGGEST'

let queuedSession: Session | undefined

function queueSession(newSession: Session) {
    if (queuedSession) {
        const { events } = queuedSession
        newSession.events.forEach((newEvent: SessionEvent) => {
            let matchedEvent = false
            events.forEach((existingEvent: SessionEvent) => {
                // add to an event's actions only if response id and event type equal
                if (
                    existingEvent.event_type === newEvent.event_type &&
                    existingEvent.response_id === newEvent.response_id
                ) {
                    matchedEvent = true
                    existingEvent.actions = [...existingEvent.actions, ...newEvent.actions]
                }
            })
            if (!matchedEvent) {
                events.push(newEvent)
            }
        })
    } else {
        queuedSession = newSession
    }
}

export const createSession = (
    // add other existing types ad hoc
    event_type: WebAppPingbackEventType,
    actions: PingbackRequestAction[],
    responseId: string = '',
    loggedInUserId: string = ''
): Session => ({
    user: {
        user_id: cookie.parse(document ? document.cookie : ({} as any)).giphy_pbid,
        logged_in_user_id: loggedInUserId || '',
    },
    events: [
        {
            event_type,
            referrer: document ? document.referrer : '',
            actions,
            response_id: responseId,
            prior_response_id: getLastSearchResponseId(),
        },
    ],
})

const sendIt = debounce(() => {
    const session = queuedSession
    queuedSession = undefined
    Logger.debug(`Send => Pingback session`, session)
    fetch(pingbackUrl, {
        method: 'POST',
        body: JSON.stringify({ sessions: [session] }),
        headers: {
            'Content-Type': 'application/json',
        },
    })
}, pingbackDebounceTime)

export const sendPingback = (session: Session) => {
    Logger.debug(`Add pingback session`, session)
    queueSession(session)
    sendIt()
}
